<kodit-dropdown
  [options]="items"
  [formCtrl]="formCtrl"
  (optionChanged)="handleOnItemChange($event)"
  [ctrlDisabled]="shouldDisable"
></kodit-dropdown>
